/**************************************************
 * Nombre:       Home_Compra_Look
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {TituloTexto} from "./SubComponentes/TituloTexto";
import Tarjeta_Look from "../../Tarjetas/Tarjeta_Look";
import {useContext, useEffect, useRef, useState} from "react";
import {contexApp} from "../../../App";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Compra_Look = () => {
    const {sCell} = useResponsive()
    const cData = useContext(contexApp)
    const refe = useRef(null)
    const [looks, setLooks] = useState([]);

    useEffect(() => {

        if (cData.looks) {
            setLooks(cData.looks);
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', px: sCell ? 0 : 3}}>
                            <TituloTexto texto={'#AMEVILOOK'} titulo={'COMPRA EL LOOK'} dir={'center'}/>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 8}}
                            spacing={4}
                        >

                            {sCell ?

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Splide
                                        ref={refe}
                                        aria-label="My Favorite Images" style={{width: '100%'}}
                                        options={{
                                            autoplay: false,
                                            speed: 1000,
                                            rewind: true,
                                            perPage: 1,
                                            arrows: false,
                                            pagination: true,
                                            width: '100%',
                                            drag: 'false',
                                            interval: 1000,
                                            noDrag: true,
                                            type: 'loop',
                                            gap: 10,
                                            padding: 30,
                                        }}
                                    >

                                        {looks.map((item, index) => (
                                            <SplideSlide>

                                                <Tarjeta_Look item={item}/>
                                            </SplideSlide>
                                        ))}


                                    </Splide>
                                </Grid>
                                :

                                looks.map((item, index) => (
                                    <Grid container size={{xs: 12, sm: 6, md: 4}}
                                          sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Look item={item}/>
                                    </Grid>
                                ))


                            }


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Compra_Look

const items = [1, 2, 3]